module.exports = __webpack_public_path__ + "static/media/04.a9f3982c.mp3";